import styled from "styled-components";
import { Colors } from "../config";
import { Error } from "../config/StyledComponents";
import InputLabel from "../components/InputLabel";

const downArrow = require("../assets/images/down-arrow.png");

const SelectField = ({
  label,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
  required,
  helperText,
  disabled,
  onChange,
  value,
  name,
  data,
  isRounded,
  placeholder,
  light,
  leftImg,
}) => {
  return (
    <SelectFieldWrapper>
      <InputLabel
        label={label}
        labelFontColor={labelFontColor}
        labelFontSize={labelFontSize}
        labelFontWeight={labelFontWeight}
        required={required}
      />
      <SelectContainer isRounded={isRounded} light={light}>
        <LeftImg src={leftImg} />
        <Select
          leftImg={leftImg}
          disabled={disabled}
          onChange={onChange}
          value={value}
          name={name}
          helperText={helperText}
          isRounded={isRounded}
          placeholder={placeholder}
        >
          {data?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </SelectContainer>
      {helperText && <Error>{helperText}</Error>}
    </SelectFieldWrapper>
  );
};

const LeftImg = styled.img`
  width: 1.5rem;
  position: absolute;
  bottom: 0.75rem;
  left: 1rem;
`;

const SelectFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SelectContainer = styled.div`
  background: ${(props) =>
    props.isRounded
      ? "none"
      : props.light
      ? Colors.white
      : Colors.brandFiveOpacity40};
  border-radius: 0.625rem;
  width: 100%;
  position: relative;
`;

const Select = styled.select`
  width: 100%;
  font-family: "Inter", sans-serif;
  overflow-y: visible;
  -webkit-appearance:none;
  background: url(${downArrow}) no-repeat; 
  background-position: calc(100% - 1rem);
  color: ${(props) =>
    props.value
      ? Colors.shark
      : props.isRounded
      ? Colors.sharkOpacity20
      : props.light
      ? Colors.sharkOpacity10
      : Colors.shark};
  font-size: 1rem;
  font-weight: 600;
  font-style: normal;
  padding-top: 0.84rem;
  padding-bottom: 0.84rem;
  padding-left:${(props) => (props.leftImg ? "2.75rem" : "0.75rem")};
  padding-right: 1.5rem;
  border-radius: ${(props) => (props.isRounded ? "2.5rem" : "0.625rem")};
  border: ${(props) =>
    props.helperText
      ? `1px solid ${Colors.red}`
      : props.isRounded
      ? `1px solid ${Colors.coolGrey}`
      : "none"};
  :focus {
    outline: none;
  }
  :disabled {
    color: ${Colors.sharkOpacity10};
    cursor:no-drop;
  }
  >option{
    @media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm) {
      color:black;
    }
  }
  }
`;

export default SelectField;
